import './progress-bar.less';
import React from 'react';
import PropTypes from 'prop-types';

export default class ProgressBar extends React.Component {
	constructor(props) {
		super(props);
		const initialState = {
			showProgressBar: false,
			timeout: null,
			containerStyle: {
				width: '100%',
				margin: 'auto'
			}
		};

		if (!this.props.isAppInitProgressBar) {
			// reset to less
			initialState.containerStyle = null;
		}

		this.state = { ...initialState };
	}
	componentDidMount() {
		let timeout = setTimeout(() => {
			this.setState({ showProgressBar: true });
		}, 200);

		this.setState({ timeout });
	}
	componentWillUnmount() {
		this.state.timeout && clearTimeout(this.state.timeout);
	}
	render() {
		return (
			<div className="progress-bar" style={this.state.containerStyle}>
				{this.state.showProgressBar ? (
					<ul className="progress-bar__bullets">
						<li />
						<li />
						<li />
					</ul>
				) : null}
			</div>
		);
	}
}

ProgressBar.propTypes = {
	isAppInitProgressBar: PropTypes.bool
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/progress-bar.js